<template>
  <v-container fluid>
    <!-- Installation commands list -->
    <v-infinite-scroll ref="infinite" class="installation-commands-list" :height="'100%'" :items="users" @load="loadMore">
      <v-list v-if="users.length > 0">
        <template v-for="(user, index) in users" :key="user.id">
          <v-list-item>
            <v-list-item-title class="font-weight-bold">
              <Avatar class="me-2" :size="32" variant="beam" :name="user.email" />
              {{ user.email }}
            </v-list-item-title>

            <template #append>
              <div class="d-flex flex-column align-end">
                <v-btn variant="elevated" density="comfortable" @click="deleteUserCb(user.id)"> Supprimer </v-btn>
              </div>
            </template>
          </v-list-item>

          <v-divider v-if="index < users.length - 1"></v-divider>
        </template>
      </v-list>

      <div v-if="loading" class="text-center py-4">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </v-infinite-scroll>
  </v-container>
</template>

<script setup lang="ts">
import { deleteUser, getUsers } from '@/api/user/api';
import { User } from '@/api/user/types';
import { Ref, ref } from 'vue';
import Avatar from 'vue-boring-avatars';

const loading = ref(false);
const page = ref(1);
const users: Ref<Array<User>> = ref([]);

let doneCallback: ((status: 'ok' | 'empty' | 'error' | 'loading') => void) | undefined = undefined;

// Load more items when scrolling
const loadMore = async ({ done }: { done: (status: 'ok' | 'empty' | 'error' | 'loading') => void }) => {
  if (!doneCallback) {
    doneCallback = done;
  }

  // Pagination not done yet - only one page
  if (page.value > 1) {
    done('empty');
    return;
  }

  const { data } = await getUsers();

  if (data.length === 0) {
    done('empty');
    return;
  }

  users.value = [...users.value, ...data];
  page.value += 1;
  done('ok');
};

// Install command action
const deleteUserCb = async (id: number) => {
  // TODO: Validate before
  await deleteUser(id);
  await refresh();
};

const refresh = async () => {
  page.value = 1;
  users.value = [];
  await loadMore({ done: doneCallback! });
};

defineExpose({
  refresh,
});
</script>

<style scoped>
.installation-commands-list {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

.urgent-installation {
  background-color: rgba(244, 67, 54, 0.05);
}

.done-installation {
  background-color: rgba(76, 175, 80, 0.05);
}

.v-list-item {
  border-radius: 8px;
  margin-bottom: 4px;
  transition: background-color 0.2s ease;
}

.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
